import { formatPrice } from '../../currency';

const PERCENT = 100;

/**
 * "Sell • 90% Value" — the buyback as a share of the card's fair market
 * value, both from the order payload (partner Figma 2026-10-08). Without a usable FMV the share can't be
 * stated, so the label falls back to the amount itself.
 */
export function sellLabel(grossPrice: number, fairMarketValue: number | null | undefined): string {
  if (fairMarketValue != null && Number.isFinite(fairMarketValue) && fairMarketValue > 0) {
    return `Sell • ${Math.round((grossPrice / fairMarketValue) * PERCENT)}% Value`;
  }
  return `Sell • ${formatPrice(grossPrice, 2)}`;
}
